import { useReducer } from "react";
import FormacionDesarolloContext,{initialState} from "./FormacionDesarrolloContext";
import FormacionDesarolloRecuder from './FormacionDesarrolloReducer'

const FormacionDesarrolloState = (props: any)=>{
    const [state,dispatch] = useReducer(FormacionDesarolloRecuder,initialState)
    return(
        <FormacionDesarolloContext.Provider value={{state,dispatch}}>
            {props.children}
        </FormacionDesarolloContext.Provider>
    )
}
export default FormacionDesarrolloState;